import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, computed, ref } from 'vue';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';
import { useTradeState } from 'ah-trades';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useRouter } from 'vue-router/composables';
import { RawLocation } from 'vue-router';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import CurvedProgressBar from '@/app/components/common/CurvedProgressBar.vue';
import AmountDisplay from '@/app/components/wallets/AmountDisplay.vue';
import { ClientPositionUsageReport } from 'ah-api-gateways';


export default /*#__PURE__*/_defineComponent({
  __name: 'LimitsDashboardWidget',
  props: {
    redirectTo: null
  },
  setup(__props: any) {

const props = __props as {
  redirectTo: RawLocation;
};



const router = useRouter();

const onBehalfOf = useOnBehalfOf();

const tradeState = useTradeState();

const clientLimits = ref<ClientPositionUsageReport>();

const requestManager = useRequestManager({
  exposeToParent: false,
  onRetryFromParentManager: loadLimits,
}).manager;

function loadLimits() {
  requestManager
    .currentOrNew(
      'loadLimitsReport',
      tradeState.services.risk.getClientPositionLimitsUsage(
        onBehalfOf.value?.id ?? tradeState.store.useAuthStore().loggedInIdentity!.client!.id,
        { errors: { silent: (error) => error.response?.status === 404 } }
      )
    )
    .subscribe((res) => (clientLimits.value = res));
}

onBeforeMount(loadLimits);

function goToLimits() {
  router.push(props.redirectTo);
}

const total = computed(() => clientLimits.value?.notionalLimitTotal ?? 0);

const remaining = computed(() =>
  Math.max(0, (clientLimits.value?.notionalLimitTotal ?? 0) - (clientLimits.value?.notionalLimitTotalInUse ?? 0))
);

const used = computed(() => clientLimits.value?.notionalLimitTotalInUse ?? 0);

const utilization = computed(() => {
  if (!clientLimits.value || used.value === 0) return 0;
  return used.value / total.value;
});

return { __sfc: true,props, router, onBehalfOf, tradeState, clientLimits, requestManager, loadLimits, goToLimits, total, remaining, used, utilization, formatCurrencyValue, CurvedProgressBar, AmountDisplay }
}

})